export enum FileExtension {
  DOCX = '.docx',
  PDF = '.pdf'
}
